module.exports = __webpack_public_path__ + "2bb644f4c4225c03fefa10e215660721.svg";